import React, { HTMLProps, useRef } from 'react';
import styled from 'styled-components';
import ArrowRightIcon from 'src/shared/material_icons/hardware/keyboard_arrow_right.svg';
import { Icon } from '../icon';

export const DialogResults = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;
    padding: 20px;
    gap: 10px;
    min-height: 0;
`;

export const DialogResultsGroup = styled.div`
    padding: 0;
    margin: 0 0 20px 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const DialogResultArrowIcon = styled(Icon)`
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    color: #999;
`;

const _DialogResult = styled.a`
    padding: 10px 20px;
    border-radius: 10px;
    background-color: #f5f5f5;
    display: flex;
    flex-direction: column;
    text-decoration: none;
    color: black;
    position: relative;
    flex: 0;
    border: 1px solid transparent;

    &[aria-selected='true'] {
        border: 1px solid ${(props) => props.theme.app.secondary};
    }
`;

export const DialogResult = ({ children, ...props }: { children: React.ReactNode } & HTMLProps<HTMLAnchorElement>) => {
    const ref = useRef<HTMLAnchorElement>(null);

    return (
        <_DialogResult {...props} ref={ref}>
            {children}
            <DialogResultArrowIcon>
                <ArrowRightIcon />
            </DialogResultArrowIcon>
        </_DialogResult>
    );
};

// Same section title as the product sidebar drawer: small, grey, all caps.
export const DialogResultTitle = styled.div`
    color: #6b7280;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
`;
